(function() {
  "use strict";
  angular.module("marketPlace.comments", []);
})();
